import { Button, Container, Switch, Typography } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import PageTitle from "../../../components/pageTitle/PageTitle";
import { Card, CardContent, CardHeader, Checkbox, FormControlLabel, FormGroup, useMediaQuery } from "@mui/material";
import styles from "../Accounts.module.scss";
import { getSettings, resetSettings, saveSettings, updateSettings } from "../../../services/apiservices/settings";
import AuthContext from "../../../hooks/authContext";
import CommonContext from "../../../hooks/commonContext";
import { useNavigate } from "react-router";
import { CommonConfirmationDialog, CommonSuccessDialog } from "../../../components/DialogComponent/SupplyDataDialog";
import MarkunreadOutlinedIcon from '@mui/icons-material/MarkunreadOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { useToast } from "../../../hooks/useToast";


const NotificationPageSetting = () => {
    const isMobile = useMediaQuery('(max-width:767px)');
    const [smsRoles, setSMSRoles] = useState([]);
    const [emailRoles, setEmailRoles] = useState([]);
    const [pushNotificationRoles, setPushNotificationRoles] = useState([]);
    const [error, setError] = useState({});
    const [data, setData] = useState();
    const auth = useContext(AuthContext);
    const commonContext = useContext(CommonContext);
    const [open, setOpen] = useState(false);
    const [updateOpen, setUpdateOpen] = useState(false);
    const [resetOpen, setResetOpen] = useState(false);
    const [resetSuccessOpen, setResetSuccessOpen] = useState(false);
    const navigate = useNavigate();
    const { toast } = useToast();

    const userTypes = [
        { label: "ADMIN USER", value: "admin" },
        { label: "SUPPORT USER", value: "support" }
    ];

    const [emailEnabled, setEmailEnabled] = useState(false);
    const [smsEnabled, setSMSEnabled] = useState(false);
    const [pushEnabled, setPushEnabled] = useState(false);

    const [openSections, setOpenSections] = useState({
        email: false,
        sms: false,
        push: false,
    });


    const fetchSettings = async () => {
        getSettings('notification_settings', (res) => {
            const companyId = auth?.userProfile?.role === "companyUser"
                ? auth?.userProfile?.id
                : auth?.userProfile?.companyId;

            if (res?.data) {
                const filteredData = res.data.filter(
                    (item) => item.companyId === companyId && !item.deleted
                );

                if (filteredData.length > 0) {
                    const [firstItem] = filteredData;
                    setData(filteredData);
                    setSMSRoles(firstItem?.smsRoles);
                    setEmailRoles(firstItem?.emailRoles);
                    setPushNotificationRoles(firstItem?.pushNotificationRoles);
                    setEmailEnabled(firstItem?.emailRoles?.length > 0 ? true : false);
                    setSMSEnabled(firstItem?.smsRoles?.length > 0 ? true : false);
                    setPushEnabled(firstItem?.pushNotificationRoles?.length > 0 ? true : false);
                    setOpenSections({email: firstItem?.emailRoles?.length > 0 ? true : false, sms: firstItem?.smsRoles?.length > 0 ? true : false, push: firstItem?.pushNotificationRoles?.length > 0 ? true : false})
                } else {
                    setData();
                    setSMSRoles([]);
                    setEmailRoles([]);
                    setPushNotificationRoles([]);
                    setEmailEnabled(false);
                    setSMSEnabled(false);
                    setPushEnabled(false);
                    setOpenSections({email: false, sms: false, push: false})
                }
            } else {
                setData();
                setSMSRoles([]);
                setEmailRoles([]);
                setPushNotificationRoles([]);
                setEmailEnabled(false);
                setSMSEnabled(false);
                setPushEnabled(false);
                setOpenSections({email: false, sms: false, push: false})
            }
        });
    };


    useEffect(() => {
        fetchSettings();
    }, []);

    const validFields = () => {
        const errormessages = {};
        let isValid = true;

        if (!smsRoles.length && (!emailRoles.length || emailRoles.length === 0) && (!pushNotificationRoles.length || pushNotificationRoles.length === 0)) {
            isValid = false;
            errormessages.sms = "SMS Roles is Required";
            errormessages.email = "Email Roles is Required";
            errormessages.push = "Push Notification Roles is Required";
        }

        setError(errormessages);
        return isValid;
    };

    const handleSaveData = async () => {
        commonContext?.setLoader(true);
        // if (!validFields()) {
        //     commonContext?.setLoader(false);
        //     return;
        // } else {
            const companyId = auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;

            const dataToSave = {
                smsRoles: smsRoles,
                emailRoles: emailRoles,
                pushNotificationRoles: pushNotificationRoles,
                companyId: companyId
            };

            const data = await saveSettings(dataToSave, 'notification_settings');
            if (data.status === true) {
              await fetchSettings();
              toast?.({title: "Success", description: "Setting Saved Successfully"});
              commonContext?.setLoader(false);
            }
            commonContext?.setLoader(false);
        // }
    };

    const handleUpdateData = async () => {
        commonContext?.setLoader(true);
        // if (!validFields()) {
        //     commonContext?.setLoader(false);
        //     return;
        // } else {
            const dataToSave = {
                smsRoles: smsRoles,
                emailRoles: emailRoles,
                pushNotificationRoles: pushNotificationRoles,
            };
            const id = data[0]?.id;

            const details = await updateSettings(dataToSave, 'notification_settings', id);
            if (details.status === true) {
              await fetchSettings();
              toast?.({title: "Success", description: "Setting Update Successfully"});
              commonContext?.setLoader(false);
            }
            commonContext?.setLoader(false);
        // }
    };


    const handleResetConfirm = async () => {
        setResetOpen(false);
        commonContext?.setLoader(true);
        const id = data[0]?.id;
        const details = await resetSettings('notification_settings', id);
        if (details.status === true) {
          await fetchSettings();
          toast?.({title: "Success", description: "Setting Reset Successfully"});
          commonContext?.setLoader(false);
        }
        commonContext?.setLoader(false);
    }

    const handleResetClose = () => {
        setResetOpen(false);
    }

    const handleResetSuccessClose = () => {
        setResetSuccessOpen(false);
        fetchSettings();
        toast?.({title: "Success", description: "Setting Reset Successfully"});
    }

    const handleColse = () => {
        setOpen(false);
        navigate("/account/settings");
        toast?.({title: "Success", description: "Setting Saved Successfully"});
    }

    const handleUpdateClose = () => {
        setUpdateOpen(false);
        navigate("/account/settings");
        toast?.({title: "Success", description: "Setting Update Successfully"});
    }

    const handleReset = () => {
        if (data) {
            setResetOpen(true);
        } else {
            setEmailRoles([]);
            setData();
            setSMSRoles([]);
            setPushNotificationRoles([]);
            setError({});
            setEmailEnabled(false);
            setSMSEnabled(false);
            setPushEnabled(false);
        }
    };


    const handleToggle = (type) => {
        const updatedState = { ...openSections, [type]: !openSections[type] };
        setOpenSections(updatedState);

        if (type === "email") setEmailEnabled(!emailEnabled);
        if (type === "sms") setSMSEnabled(!smsEnabled);
        if (type === "push") setPushEnabled(!pushEnabled);
    };

    const handleRoleChange = (type, role) => {
        const setter =
            type === "email" ? setEmailRoles :
                type === "sms" ? setSMSRoles :
                    setPushNotificationRoles;

        const roles =
            type === "email" ? emailRoles :
                type === "sms" ? smsRoles :
                    pushNotificationRoles;

        const updated = roles.includes(role)
            ? roles.filter((r) => r !== role)
            : [...roles, role];

        setter(updated);
    };

    const handleToggleAllUsers = (type) => {
        const setter =
            type === "email" ? setEmailRoles :
                type === "sms" ? setSMSRoles :
                    setPushNotificationRoles;

        const roles =
            type === "email" ? emailRoles :
                type === "sms" ? smsRoles :
                    pushNotificationRoles;

        const allValues = userTypes.map(user => user.value);
        const shouldClear = roles.length === allValues.length;

        setter(shouldClear ? [] : allValues);
    };

    const renderSection = (type, IconComponent, title, description, enabled, roles) => (
        <>
            <div className={`${styles.notificationSection} d-flex flex-direction-column shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}>
                <FormControlLabel
                    className={styles.notificationToggle}
                    label={
                        <div className={styles.labelGroup}>
                            <IconComponent
                                fontSize="small"
                                className={
                                    type === "email"
                                        ? styles.iconEmail
                                        : type === "sms"
                                            ? styles.iconSMS
                                            : styles.iconPush
                                }
                            />
                            <div>
                                <Typography className={`${styles.labelTitle} dark:text-white`}>{title}</Typography>
                                <Typography className={styles.labelDescription}>{description}</Typography>
                            </div>
                        </div>
                    }
                    labelPlacement="start"
                    control={
                        <Switch
                            color="primary"
                            checked={enabled}
                            onChange={() => handleToggle(type)}
                        />
                    }
                />
            </div>
            {error[type] && (
                <Typography
                  variant="body2"
                  color="error"
                  className="mt-4 ml-48"
                >
                  {error[type]}
                </Typography>
              )}
            {openSections[type] && (
                <div className={styles.userTypesContainer}>
                    <div className={styles.userTypeHeader}>
                        <Typography className={`${styles.userTypeLabel} dark:text-white`}>User Types</Typography>
                        <Button
                            size="small"
                            variant="outlined"
                            className={`${styles.toggleAllButton} dark:text-white`}
                            onClick={() => handleToggleAllUsers(type)}
                        >
                            Toggle All
                        </Button>
                    </div>
                    <FormGroup className={`${styles.notificationSection} mt-8 shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}>
                        {userTypes.map(({ label, value }) => (
                            <FormControlLabel
                                key={value}
                                control={
                                    <Checkbox
                                        sx={{
                                            '&.Mui-checked': {
                                                color: '#078037',
                                            },
                                            '&.Mui-checked + .MuiSwitch-track': {
                                                backgroundColor: '#078037',
                                            }
                                        }}
                                        checked={roles.includes(value)}
                                        onChange={() => handleRoleChange(type, value)}
                                    />
                                }
                                className="dark:text-white text-[#020817]"
                                label={label}
                            />
                        ))}
                    </FormGroup>
                </div>
            )}
        </>
    );

    return (
      <>
        <Container>
          <PageTitle
            pageTitle="Notification Settings"
            showBreadcrumb={[
              { label: "Home", to: "/" },
              { label: "Settings", to: "/account/settings" },
            ]}
            BreadCrumbCurrentPageTitle={"Notification Settings"}
            showLastSeen={true}
          />
          <div className="sectionBox dark:bg-[#1A1F2C]">
            <div>
              <div
                className="mb-8 d-flex flex-direction-column"
                style={{
                  margin: "16px auto auto auto",
                  justifyContent: "flex-start",
                  maxWidth: "800px",
                }}
              >
                <h2 className="text-foreground">Notification Settings</h2>
                <p style={{ color: "#64748B", marginTop: "12px" }}>
                  Manage how you receive notifications and updates.
                </p>
              </div>
              <Card className={`${styles.notificationCard} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]  dark:text-white dark:border-none`}>
                <CardHeader
                  title={
                    <span
                      style={{
                        fontSize: "24px",
                        lineHeight: "1",
                      }}
                      className="text-foreground"
                    >
                      Notification Preferences
                    </span>
                  }
                  subheader={
                    <span
                      style={{
                        color: "#64748B",
                        fontSize: "14px",
                        marginTop: "8px",
                      }}
                    >
                    Manage who can send notifications and through which channels. Select the user roles that are allowed to notify employees via email, SMS or push notifications.
                    </span>
                  }
                  className={styles.cardHeader}
                />
                <CardContent className={styles.cardContent}>
                  {renderSection(
                    "email",
                    MarkunreadOutlinedIcon,
                    "Email Notifications",
                    "Enable or disable the ability for selected user roles to send notifications via email. Only the roles you select will be able to email employees.",
                    emailEnabled,
                    emailRoles
                  )}
                  {renderSection(
                    "sms",
                    ChatBubbleOutlineOutlinedIcon,
                    "SMS Notifications",
                    "Enable or disable the ability for selected user roles to send notifications via text message (SMS). Only the roles you select will be able to send SMS to employees.",
                    smsEnabled,
                    smsRoles
                  )}
                  {renderSection(
                    "push",
                    NotificationsNoneOutlinedIcon,
                    "Push Notifications",
                    "Enable or disable the ability for selected user roles to send mobile app push notifications. Only the roles you select will be able to send push alerts to employees.",
                    pushEnabled,
                    pushNotificationRoles
                  )}
                </CardContent>
              </Card>
              <div
                style={{
                  margin: "45px auto auto auto",
                  display: "flex",
                  justifyContent: "flex-start",
                  maxWidth: "800px",
                  gap: "12px",
                }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  style={{ color: "white", backgroundColor: "#078037" }}
                  onClick={data ? handleUpdateData : handleSaveData}
                >
                  Save Changes
                </Button>
                <Button type="button" variant="outlined" onClick={() => navigate("/account/settings")} className="dark:text-white">
                  Cancel
                </Button>
                <Button type="button" variant="outlined" onClick={handleReset} className="dark:text-white">
                  Reset to Default
                </Button>
              </div>
            </div>
          </div>
        </Container>
        {open && (
          <CommonSuccessDialog
            open={open}
            onClose={handleColse}
            title={"Success"}
            message={"Your settings have been successfully saved."}
          />
        )}
        {updateOpen && (
          <CommonSuccessDialog
            open={updateOpen}
            onClose={handleUpdateClose}
            title={"Success"}
            message={"Your settings have been successfully update."}
          />
        )}
        {resetOpen && (
          <CommonConfirmationDialog
            open={resetOpen}
            onConfirm={handleResetConfirm}
            onClose={handleResetClose}
            title={"Setting Reset"}
            message={"Are you sure you want to reset the settings?"}
            buttonTitle={"Yes"}
          />
        )}
        {resetSuccessOpen && (
          <CommonSuccessDialog
            open={resetSuccessOpen}
            onClose={handleResetSuccessClose}
            title={"Success"}
            message={"Your settings have been successfully reset."}
          />
        )}
      </>
    );

}
export default NotificationPageSetting;